module.exports = __webpack_public_path__ + "static/media/UD02.3c34d786.png";